/* eslint-disable comma-dangle, indent, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var ReactDOM = require("react-dom");
var _2 = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var GraphUtils = require("../util/graph-utils.js");

var defaultImage = {
    url: null,
    top: 0,
    left: 0
};

var Measurer = React.createClass({
    displayName: "Measurer",

    propTypes: {
        apiOptions: ApiOptions.propTypes,
        box: React.PropTypes.arrayOf(React.PropTypes.number),
        image: React.PropTypes.shape({
            url: React.PropTypes.string,
            top: React.PropTypes.number,
            left: React.PropTypes.number
        }),
        showProtractor: React.PropTypes.bool,
        protractorX: React.PropTypes.number,
        protractorY: React.PropTypes.number,
        showRuler: React.PropTypes.bool,
        rulerLabel: React.PropTypes.string,
        rulerTicks: React.PropTypes.number,
        rulerPixels: React.PropTypes.number,
        rulerLength: React.PropTypes.number
    },

    getDefaultProps: function getDefaultProps() {
        return {
            box: [480, 480],
            image: {},
            showProtractor: true,
            protractorX: 7.5,
            protractorY: 0.5,
            showRuler: false,
            rulerLabel: "",
            rulerTicks: 10,
            rulerPixels: 40,
            rulerLength: 10
        };
    },

    getInitialState: function getInitialState() {
        return {};
    },

    render: function render() {
        var image = _2.extend({}, defaultImage, this.props.image);
        return React.createElement(
            "div",
            {
                className: "perseus-widget perseus-widget-measurer " + "graphie-container above-scratchpad",
                style: { width: this.props.box[0], height: this.props.box[1] }
            },
            image.url && React.createElement("img", {
                src: image.url,
                style: {
                    top: image.top,
                    left: image.left
                }
            }),
            React.createElement("div", { className: "graphie", ref: "graphieDiv" })
        );
    },

    componentDidMount: function componentDidMount() {
        this.setupGraphie();
    },

    componentDidUpdate: function componentDidUpdate(prevProps) {
        var shouldSetupGraphie = _2.any(["box", "showProtractor", "showRuler", "rulerLabel", "rulerTicks", "rulerPixels", "rulerLength"], function (prop) {
            return prevProps[prop] !== this.props[prop];
        }, this);

        if (shouldSetupGraphie) {
            this.setupGraphie();
        }
    },

    setupGraphie: function setupGraphie() {
        var graphieDiv = ReactDOM.findDOMNode(this.refs.graphieDiv);
        $(graphieDiv).empty();
        var graphie = this.graphie = GraphUtils.createGraphie(graphieDiv);

        var scale = [40, 40];
        var range = [[0, this.props.box[0] / scale[0]], [0, this.props.box[1] / scale[1]]];
        graphie.init({
            range: range,
            scale: scale
        });
        graphie.addMouseLayer({
            allowScratchpad: true,
            setDrawingAreaAvailable: this.props.apiOptions.setDrawingAreaAvailable
        });

        if (this.protractor) {
            this.protractor.remove();
        }

        if (this.props.showProtractor) {
            this.protractor = graphie.protractor([this.props.protractorX, this.props.protractorY]);
        }

        if (this.ruler) {
            this.ruler.remove();
        }

        if (this.props.showRuler) {
            this.ruler = graphie.ruler({
                center: [(range[0][0] + range[0][1]) / 2, (range[1][0] + range[1][1]) / 2],
                label: this.props.rulerLabel,
                pixelsPerUnit: this.props.rulerPixels,
                ticksPerUnit: this.props.rulerTicks,
                units: this.props.rulerLength
            });
        }
    },

    getUserInput: function getUserInput() {
        return {};
    },

    simpleValidate: function simpleValidate(rubric) {
        // TODO(joel) - I don't understand how this is useful!
        return Measurer.validate(this.getUserInput(), rubric);
    },

    focus: $.noop
});

_2.extend(Measurer, {
    validate: function validate(state, rubric) {
        return {
            type: "points",
            earned: 1,
            total: 1,
            message: null
        };
    }
});

var propUpgrades = {
    1: function _(v0props) {
        var v1props = _2(v0props).chain().omit("imageUrl", "imageTop", "imageLeft").extend({
            image: {
                url: v0props.imageUrl,
                top: v0props.imageTop,
                left: v0props.imageLeft
            }
        }).value();
        return v1props;
    }
};

module.exports = {
    name: "measurer",
    displayName: "Measurer",
    widget: Measurer,
    version: { major: 1, minor: 0 },
    propUpgrades: propUpgrades
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/measurer.jsx
 ** module id = 126
 ** module chunks = 0 1
 **/